module.exports = __webpack_public_path__ + "static/logo-110a6d727a0dd219d6d6b17ed6754ec9.png";